import React from "react";
import { MobileBidDetailsProps } from "./mobile-bid-details.interface";
import styles from "./mobile-bid-details.module.scss";
import { dateAndTimeFormat, formatCurrency, pstDateFormat } from "../../../../utils/utils";

const MobileBidDetails = ({
  title,
  dateTimeTitle,
  dateTime,
  company,
  company_subtitle,
  offersDueTitle,
  offersDateTime,
  closeTitle,
  closeDate,
  depositTitle,
  amount,
  sales,
  salesInstruction,
  currencyCode,
  locale
}: MobileBidDetailsProps) => {
  const amount1 = amount || 0;
  return (
    <div className={styles.bidDetails} tabIndex={15}>
      <div className={styles.title}>{title}</div>
      <div className={styles.bidWrap}>
        <div className={styles.bidBox}>
          <div className={styles.bidTitle}>{dateTimeTitle}</div>
          <div className={styles.bidText}>
            {dateAndTimeFormat(dateTime) || "N/A"}
          </div>
        </div>

        <div className={styles.bidBox}>
          <div className={styles.bidTitle}>{company}</div>
          <div className={styles.bidText}>{company_subtitle || "N/A"}</div>
        </div>
      </div>

      <div className={styles.bidWrap}>
        <div className={styles.bidBox}>
          <div className={styles.bidTitle}>{offersDueTitle}</div>
          <div className={styles.bidText}>
            {offersDateTime ? dateAndTimeFormat(offersDateTime) : "N/A"}
          </div>
        </div>

        <div className={styles.bidBox}>
          <div className={styles.bidTitle}>{closeTitle}</div>
          <div className={styles.bidText}>
            {closeDate ? pstDateFormat(closeDate) : "N/A"}
          </div>
        </div>
      </div>

      <div className={styles.bidWrap}>
        <div className={styles.bidBox}>
          <div className={styles.bidTitle}>{depositTitle}</div>
          <div className={styles.bidText}>
            {amount1 > 0
              ? formatCurrency(amount1, currencyCode, locale, 0, 0)
              : "N/A"}
          </div>
        </div>
        <div className={styles.bidBox}>
          <div className={styles.bidTitle}>{sales}</div>
          <div className={styles.bidText}>{salesInstruction || "N/A"}</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(MobileBidDetails);
